import _ from '@lodash';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import RegistrationFormPage from './RegistrationFormPage';
import UserAccountService from './service/UserAccountService';

const config = () => {
	const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
	const blockTitleClassName = 'py-8';

	return {
		key: 'UserRegistrationForm',
		text: 'HelloCaptcha Registration',
		textKey: 'UserRegistrationForm',
		service: UserAccountService,
		defaultValue: () =>
			new Promise((resolve, reject) => {
				resolve({
					id: null,
					email: null,
					password: null,
					passwordAgain: null
				});
			}),
		fields: [
			{
				key: 'nameGroup',
				component: EditFormGroupFields,
				className: 'w-full flex flex-col sm:flex-row',
				fields: [
					{
						key: 'name',
						text: 'Name',
						textKey: 'name',
						className: 'sm:mr-6',
						component: EditFormTextField,
						maxLength: 50,
						required: true,
						autoCapitalize: 'capitalize'
					}
				]
			},
			{
				key: 'email',
				text: 'E-mail address',
				textKey: 'email',
				component: EditFormTextField,
				maxLength: 100,
				required: true
			},
			{
				key: 'fullPasswordGroup',
				component: EditFormGroupFields,
				className: blockClassName,
				fields: [
					{
						key: 'password',
						text: 'Password',
						textKey: 'password',
						component: EditFormSeparatorField,
						icon: 'lock',
						className: blockTitleClassName,
						isControlledInput: false
					},
					{
						key: 'passwordGroup',
						component: EditFormGroupFields,
						className: 'w-full flex flex-col sm:flex-row',
						fields: [
							{
								key: 'password',
								text: 'Password',
								textKey: 'password',
								className: 'sm:mr-6',
								component: EditFormTextField,
								required: true,
								type: 'password',
								autoComplete: 'new-password',
								maxLength: 50
							},
							{
								key: 'passwordAgain',
								text: 'Password Again',
								textKey: 'passwordAgain',
								className: 'sm:ml-6',
								component: EditFormTextField,
								required: true,
								type: 'password',
								autoComplete: 'new-password',
								maxLength: 50
							}
						]
					}
				]
			}
		]
	};
};

function UserRegistrationForm() {
	const myConfig = config();
	return <RegistrationFormPage config={myConfig} />;
}

export default UserRegistrationForm;
